import {
  defaultPosition,
} from '../../components/GeneralCRUDComponent/FormFields/GoogleMapField/GoogleMapField';
import {
  ICountry,
} from './authInterface';
import { RequestStatus } from 'mobx-store';

export interface IBranchStore {
  branchesList: Branch[];
  wdcBranchesList: any[];
  selectedBranch: Branch;
  loading: boolean;
  getBranchesRequestStatus: RequestStatus;

  getBranches(availableCountries: ICountry[], langCode?: string, status?: string): Promise<Branch[]>;

  filterBranches(availableCountries: ICountry[], query: string, langCode?: string): Promise<Branch[]>;

  getBranchById(id: number, langCode?: string): Promise<Branch> ;

  createBranch(newBranch: Branch, langCode?: string): Promise<any>;

  updateBranch(updatedBranch: Branch, id: number, initImagesGallery: {imageUrl: string; key: number}[],
    initVideosGallery: {url: string; key: number}[], initImages360Gallery: {url: string; key: number}[],
    langCode?: string): Promise<any>;

  updateBranchStatus(updatedBranchStatus: boolean, index: number): Promise<any>;

  getWDCBranches(langCode?: string, selectedWdcBranch?: number): Promise<any>;
}

export enum MediaTypes {
  Image = 'image',
  Image360 = 'image360',
  Video = 'video',
}

export interface MediaFile {
  mediaId: number;
  mediaType: MediaTypes;
  url: string;
}

export interface Image {
  imageUrl: string;
  key: number;
  type?: string;
}

export interface Video {
  url: string;
  key: number;
  type?: string;
}

export interface Image360 {
  url: string;
  key: number;
  type?: string;
}

export interface BranchRating {
  branchId: number;
  branchTitle: string;
  branchBackgroundImageURL: string;
  facilitiesRating: number;
}

export interface Location {
  latitude: number;
  longitude: number;
}

export interface Feature {
  branchFeatureId: number;
  iconURL: string;
  title: string;
}

export class Branch {
  id: number;

  isActive: boolean;

  title: string;

  isWaterfront: boolean;

  description: string;

  location: Location;

  images: (Image | File)[];

  videos: (Video | File)[];

  images360: (Image360 | File)[];

  wdcBranch: number;

  backgroundImage: (Image | File)[];

  masterPlanImage: (Image | File)[];

  availableCountries: string[];

  features: number[] = [];

  constructor() {
    this.id = 0;
    this.isActive = true;
    this.title = '';
    this.isWaterfront = false;
    this.description = '';
    this.location = defaultPosition;
    this.images = [];
    this.videos = [];
    this.images360 = [];
    this.wdcBranch = 0;
    this.backgroundImage = [];
    this.masterPlanImage = [];
    this.availableCountries = [];
    this.features = [];
  }

  setId(id: number): void {
    this.id = id;
  }

  getId(): number {
    return this.id;
  }

  setIsActive(status: boolean): void {
    this.isActive = status;
  }

  getIsActive(): boolean {
    return this.isActive;
  }

  getTitle(): string {
    return this.title;
  }

  setTitle(value: string): void {
    this.title = value;
  }

  getIsWaterfront(): boolean {
    return this.isWaterfront;
  }

  setIsWaterfront(status: boolean): void {
    this.isWaterfront = status;
  }

  getDescription(): string {
    return this.description;
  }

  setDescription(value: string): void {
    this.description = value;
  }

  getLocation(): Location {
    return this.location;
  }

  setLocation(location: Location): void {
    this.location = location;
  }

  getImages(): (Image | File)[] {
    return this.images;
  }

  setImages(images: (Image | File)[]): void {
    this.images = images;
  }

  getVideos(): (Video | File)[] {
    return this.videos;
  }

  setVideos(videos: (Video | File)[]): void {
    this.videos = videos;
  }

  getImages360(): (Image360 | File)[] {
    return this.images360;
  }

  setImages360(images360: (Image360 | File)[]): void {
    this.images360 = images360;
  }

  setWdcBranch(wdcBranch: number): void {
    this.wdcBranch = wdcBranch;
  }

  getWdcBranch(): number {
    return this.wdcBranch;
  }

  getBackgroundImage(): (Image | File)[] {
    return this.backgroundImage;
  }

  setBackgroundImage(backgroundImage: (Image | File)[]): void {
    this.backgroundImage = backgroundImage;
  }

  getMasterPlanImage(): (Image | File)[] {
    return this.masterPlanImage;
  }

  setMasterPlanImage(images: (Image | File)[]): void {
    this.masterPlanImage = images;
  }

  getFeatures(): number[] {
    return this.features;
  }

  setFeatures(featureIds: number[]): void {
    this.features = featureIds;
  }
}

export interface BranchDTO {
  createdAt: string;
  branchId: number;
  longitude: number;
  latitude: number;
  wdcBranchId: number;
  backgroundImageURL: string;
  masterPlanImageURL: string;
  branchImages: {
    branchImageId: number;
    imageURL: string;
  }[];
  features: Feature[];
  waterfrontBranch: {
    wfBranchId: number;
  };
  media: MediaFile[];
  facilities: {
    facilityId: number;
    isActive: boolean;
    media: MediaFile[],
    name: string
  }[];
  city: {
    name: string;
  };
  title: string;
  description: string;
  branchGallery: string[][];
}
